import React from 'react';
import './Contactus.css';
import megaphoneImage from '../Imges/AnnouncementFinal.png';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-content">
        <h2>Are you looking to make your presence visible?</h2>
        <a href="#contact" className="cta-btn">Contact Us</a>
      </div>
      <div className="cta-image">
        <img src={megaphoneImage} alt="Man with megaphone" />
      </div>
    </section>
  );
};

export default CTASection;
